export const supportedCurrencies = [
    "AED",
    "ALL",
    "AUD",
    "CAD",
    "CHF",
    "CNY",
    "DKK",
    "EUR",
    "GBP",
    "HUF",
    "IDR",
    "ISK",
    "JPY",
    "MAD",
    "MYR",
    "NOK",
    "PHP",
    "PLN",
    "SAR",
    "SEK",
    "SGD",
    "THB",
    "TRY",
    "USD",
    "VND",
];
export const currencySymbol = {
    AED: "د.إ",
    ALL: "L",
    AUD: "A$",
    CAD: "C$",
    CHF: "Fr",
    CNY: "¥",
    DKK: "kr",
    EUR: "€",
    GBP: "£",
    HUF: "Ft",
    IDR: "Rp",
    ISK: "kr",
    JPY: "¥",
    MAD: "MAD",
    MYR: "RM",
    NOK: "kr",
    PHP: "₱",
    PLN: "zł",
    SAR: "\u20C1",
    SEK: "kr",
    SGD: "S$",
    THB: "฿",
    TRY: "TRY",
    USD: "$",
    VND: "₫",
};
export const currencyName = {
    AED: "UAE Dirham",
    ALL: "Albanian Lek",
    AUD: "Australian Dollar",
    CAD: "Canadian Dollar",
    CHF: "Swiss Franc",
    CNY: "人民币",
    DKK: "Danske kroner",
    EUR: "Euro",
    GBP: "Pound sterling",
    HUF: "Hungarian Forint",
    IDR: "Indonesian Rupiah",
    ISK: "Íslensk króna",
    JPY: "Japanese Yen",
    MAD: "Moroccan Dirham",
    MYR: "Ringgit",
    NOK: "Norsk krone",
    PHP: "Philippine Peso",
    PLN: "Złoty",
    SAR: "ريال سعودي",
    SEK: "Svensk krona",
    SGD: "Singapore Dollar",
    THB: "Baht",
    TRY: "Türk Lirası",
    USD: "United States Dollar",
    VND: "Vietnamese Dong",
};
export const localeToCurrencyMapping = {
    "ar-SA": "SAR",
    "da-DK": "DKK",
    "de-DE": "EUR",
    "en-GB": "GBP",
    "en-IE": "EUR",
    "en-US": "USD",
    "es-ES": "EUR",
    "fr-FR": "EUR",
    "fr-MA": "MAD",
    "is-IS": "ISK",
    "it-IT": "EUR",
    "ms-MY": "MYR",
    "nb-NO": "NOK",
    "pl-PL": "PLN",
    "pt-PT": "EUR",
    "sv-SE": "SEK",
    "th-TH": "THB",
    "tr-TR": "TRY",
    "zh-CN": "CNY",
};
